import React from 'react';

export default class TypeSet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        name : props.name
      ,  tex : props.tex
    }
  }
  
  render() {
    return (
      <span className="typeset">{this.state.name}</span>
    );
  }
}

export const stringSet = <TypeSet name="S" tex='\mathbb{\Sigma}' />;
